/**
 * Google Drive Tab in media manager
 *
 * @see http://pucksart.com/wordpress-javascript-media-library/
 *
 */
e.Me.google_drive = {
	/**
	 * The element which opened the library view
	 * Can be used for triggering an event with the
	 * attachment info
	 *
	 * @see this._send_attachment()
	 */
	opening_element : {},

	/**
	 * Text we assign to the library button
	 *
	 * @var string
	 */
	button_text : '',

	/**
	 * The last item that was selected from the media manager
	 *
	 * @var object
	 */
	selected_item : {},

	/**
	 * Type of library we are on
	 * set during this._set_tab_contents
	 */
	library_type : '',

	order_by_title : false,
	search         : null,
	page           : 1,

	typingTimer    : '',


	/**
	 * Get things rolling
	 */
	init : function(){
		if( config.is_google_authenticated && typeof( wp ) != "undefined" && typeof( wp.media ) != "undefined" ){
			
			_.bindAll( this, '_update_order_by', '_update_tab_contents' );
			this._add_tab();
			this._set_tab_contents();

			e.el.body.on( 'click', '.media-drive-item', function(){
				e.Me.selected_item = $( this );
				$( '.drive-item-submit' ).removeAttr( 'disabled' );
			} );

			e.el.body.on( 'keyup', '#drive-search-input', function(){
				clearTimeout( e.Me.google_drive.typingTimer );
				e.Me.google_drive.search = $( this ).val();
				e.Me.google_drive.typingTimer = setTimeout( function(){
					e.Me.google_drive.page = 1;
					e.Me.google_drive._update_tab_contents();
				}, 500 );

			} );

			e.el.body.on( 'click', '#drive-order-by a', function(){
				e.Me.google_drive._update_order_by( $( this ) );
			});

			e.el.body.on( 'click', '.drive-pagination a', function(){
				e.Me.google_drive._update_page( $( this ) );
			});

			e.el.body.on( 'click', '.drive-item-submit', this._import_attachment );
		}
	},

	/**
	 * A paginate link was clicked
	 *
	 * @param {object} el
	 * @private
	 */
	_update_page : function( el ){
		this.page = el.data( 'page' );
		this._update_tab_contents();
	},



	/**
	 * Update the order by links and the list
	 * of items based on the clicked link's value
	 *
	 *
	 * @param el
	 * @private
	 */
	_update_order_by : function( el ){
		$( '#drive-order-by' ).find( 'a' ).removeClass( 'active' );
		el.addClass( 'active' );
		this.order_by_title = el.data( 'order_by_title' );

		this._update_tab_contents();
	},


	/**
	 * Updates the tabs content with the results from a search
	 *
	 * @param {string} search
	 * @private
	 */
	_update_tab_contents : function(){
		var data = {
			type           : this.library_type,
			s              : this.search,
			order_by_title : this.order_by_title,
			page           : this.page
		};

		EdSpireAjax.Request( "\\Edspire\\Media_Manager\\Google_Drive", 'ajax_get_docs', data  , function( content ){
			jQuery( ".media-frame-content #google-drive-items" ).replaceWith( content );
		});
	},


	/**
	 * Sends data about the select attachment back so
	 * it may be imported. Once the import is done we
	 * get the attachment object back.
	 *
	 * We then supply our this._send_attachment with the
	 * attachment and the process continues
	 *
	 * @uses this._send_attachment()
	 *
	 */
	_import_attachment : function(){
		var $item = e.Me.selected_item;

		var data = {
			url         : $item.data( 'import-url' ),
			title       : $item.data( 'title' )
		};
		if( $item.data( 'extension' ) != '' ){
			data.mime = $item.data( 'extension' );
		}
		EdSpireAjax.Request( "\\Edspire\\Media_Manager\\Google_Drive", 'ajax_import_doc',  data, function( attachment ){
			e.Me.google_drive._send_attachment( attachment );
		} );
	},


	/**
	 *
	 * Pass the attachment object back as an event trigger
	 * on whatever the last element assigned to the object
	 * was.
	 *
	 * When opening the library this.opening_element must be
	 * assigned to whatever will catch the trigger
	 *
	 *  @example from within the click handler
	 * EdspireGrunt.Media_Manager.google_drive.opening_element = $(this);
	 * 	$( this ).unbind( 'drive-attachment' );
	    $( this ).on( 'drive-attachment', function( ev, attachment ){
				EdSpireDashboardObj.mediaUpload.add( div, attachment.id, attachment.title, attachment );
	   });
	 *
	 * @param object attachment
	 * @private
	 */
	_send_attachment : function( $attachment ){
		$( '.media-modal-close' ).click();

		this.opening_element.trigger( 'drive-attachment', $attachment );
	},

	/**
	 * Fill the google drive tab with items
	 *
	 * @example
	 * var custom_uploader = wp.media( {
				title : 'Upload an item to your library',
				button : {
					text : 'Use selected items'
				},
				library : {
					type : 'image'
				},
				google_drive : true

			} ).on( 'select',function(){
			} ).open();
	 *
	 * @see this._send_attachment()
	 *
	 * @private
	 */
	_add_tab : function(){
		wp.media.view.MediaFrame.Select = wp.media.view.MediaFrame.Select.extend( {
			browseRouter : function( routerView ){
				var $views = {
					upload : {
						text : config.i18n.upload_files,
						priority : 20
					},
					browse : {
						text : config.i18n.my_library,
						priority : 30
					}

				};

				//we only want this extra view if we specified google_drive when calling wp.media
				if( typeof( routerView.controller.options.google_drive ) != 'undefined' ){
					$views.google_drive = {
						text : config.i18n.google_drive,
						priority : 40
					}
				}

				routerView.set( $views );
			}
		} );

	},


	/**
	 * Add a google drive tab to media manager
	 *
	 * @private
	 */
	 _set_tab_contents : function(){
		wp.media.view.Router = wp.media.view.Router.extend( {
			select : function( id ){
				var view = this.get( id );
				this.deselect();
				if( view && view.$el ){
					view.$el.addClass( 'active' );
				}

				if( id == "google_drive" ){
					e.Me.google_drive.library_type = this.controller.options.library.type;
					EdspireGrunt.Media_Manager.button_text = this.controller.options.button.text;
					EdSpireAjax.Request( "\\Edspire\\Media_Manager\\Google_Drive", 'ajax_get_docs',  { type : e.Me.google_drive.library_type }, function( content ){
						jQuery( ".media-frame-content" ).html( content );

						//add our own button so we don't conflict with theirs
						var $button = $( '.media-toolbar-primary.search-form' );
						$button.hide();

						if( $( '.drive-item-select' ).length == 0 ){
							$button.after( '<div class="media-toolbar-primary drive-select"><a href="#" class="button media-button button-primary button-large media-button-select drive-item-submit" disabled="disabled">' + EdspireGrunt.Media_Manager.button_text + '</a></div>' );
						} else {
							$( '.media-toolbar-primary.drive-select' ).show();
						}

					} );

				} else {
					$( '.media-toolbar-primary.drive-select' ).hide();
					$( '.media-toolbar-primary.search-form' ).show();
				}
			}
		} );
	}

};